import {Component, inject} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {RegistrationService} from "../core/service/auth/registration.service";
import {authStore ,AuthStore} from "../core/service/auth/auth.store";
import {TranslatePipe} from "@ngx-translate/core";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-login-page',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    RouterLink
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
  styles: ' :host{ @apply flex flex-col min-h-screen justify-center bg-primary; }'
})
export class LoginPageComponent {
  registrationService = inject(RegistrationService)
  authStore: AuthStore = inject(authStore)


  loginForm = new FormGroup({
    email: new FormControl(''),
    password: new FormControl('')
  })

  onLoginAttempt(){
    if( this.loginForm.value.email === "" && this.loginForm.value.password === "") return;
    this.authStore.login(this.loginForm.value.email, this.loginForm.value.password);
  }



}
